import { isSameDay } from '@internationalized/date'

import { nativeToAriaDate } from '@utils/dates.ts'

import type { Scan } from '@state/scans.ts'
import type { DateValue } from 'react-aria-components'

export function calculateScanDates(scans: Scan[], currentScanDate: Date) {
  const availableDates = scans
    .map(scan => scan.scanDate)
    .sort((a, b) => a.getTime() - b.getTime())
    .map(date => nativeToAriaDate(date))

  const parsedCurrentScanDate = nativeToAriaDate(currentScanDate)
  const currentScanDateIndex = availableDates.findIndex(d => isSameDay(d, parsedCurrentScanDate))

  const minScanDate = availableDates[0]
  const maxScanDate = availableDates[availableDates.length - 1]

  const previousScanDate = availableDates[currentScanDateIndex - 1]
  const nextScanDate = availableDates[currentScanDateIndex + 1]

  function isDateAvailable(date: DateValue) {
    return availableDates.some(d => isSameDay(d, date))
  }

  function getScanByDate(date: DateValue) {
    return scans.find(scan => isSameDay(nativeToAriaDate(scan.scanDate), date))
  }

  return {
    currentScanDate: parsedCurrentScanDate,
    previousScanDate,
    nextScanDate,
    minScanDate,
    maxScanDate,
    isDateAvailable,
    getScanByDate,
  }
}